<template>
    <div class="form-group">
        <label for="name">{{ title }}:</label>
        <select v-model="content" :name="name" class="form-control" @change="handleInput" :multiple="multiple">
            <option v-if="placeholder" :selected="value == ''" disabled>{{ placeholder }}</option>
            <option v-for="item in items" :key="item.id" :value="item[attributeValue]">{{ item[attributeName] }}</option>
        </select>
        <p v-if="errors[name]" class="text-center alert alert-danger">{{ errors[name][0] }}</p>
    </div>
</template>

<script>
export default{
  name: 'vSelect',
  props: {
    name: { default: '' },
    title: { default: '' },
    value: { default: '' },
    items: { default: () => ({}) },
    attributeValue: { default: 'id' },
    attributeName: { default: 'name' },
    placeholder: { default: false },
    multiple: { type: Boolean, default: false }
  },
  data() {
    return{
      content: this.value,
      errors: {}
    }
  },
  mounted() {
    this.$emit('input', this.value === null ? '' : this.value)
    Event.listen('errors', (e) => {
      this.errors = e
    })
  },
  watch: {
    value: function(newVal, oldVal) {
      this.content = newVal
    }
  },
  methods: {
    handleInput (e) {
      this.$emit('input', this.content)
      this.$delete(this.errors, this.name)
    }
  }
};
</script>
